module.exports = __webpack_public_path__ + "static/deeca-logo-575e35f010dfb949017d4c6b685a4b69.png";